import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import useCurrentInstance from "@/hooks/useCurrentInstance";
export default defineComponent({
  name: "ExamDetail",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var store = useStore();
    var allslist = reactive({
      list: {
        allpeerScore: 0,
        listId: 8,
        title: "",
        peerScore: '',
        selfScore: '',
        secretaryScore: '',
        selfDetail: [{
          optionId: 0,
          optionName: "",
          maxScore: 0
        }, {
          optionId: 0,
          optionName: "",
          maxScore: 0
        }],
        selfOpinion: "",
        peerDetail: [{
          peerId: 160,
          sore: 0,
          peerDetail: [{
            optionId: 0,
            optionName: "",
            maxScore: 0
          }, {
            optionId: 0,
            optionName: "",
            maxScore: 0
          }]
        }],
        secretaryDetail: [{
          optionId: 0,
          optionName: "",
          maxScore: 0
        }, {
          optionId: 0,
          optionName: "",
          maxScore: 0
        }],
        secretaryOpinion: ""
      }
    });
    var Data = reactive({
      topData: {
        startTime: "2022-01-04 13:13:10",
        endTime: "2022-01-13 00:00:00",
        leftData: [{
          label: "姓名",
          english: "",
          value: ""
        }, {
          label: "性别",
          english: "",
          value: ""
        }, {
          label: "出生日期",
          english: "",
          value: ""
        }, {
          label: "民族",
          english: "",
          value: ""
        }, {
          label: "手机号",
          english: "",
          value: ""
        }, {
          label: "党内职务",
          english: "",
          value: ""
        }, {
          label: "所在组织",
          english: "",
          value: ""
        }],
        rightData: [{
          label: "籍贯",
          english: "",
          value: ""
        }, {
          label: "学历",
          english: "",
          value: ""
        }, {
          label: "学位",
          english: "",
          value: ""
        }, {
          label: "入党时间",
          english: "",
          value: ""
        }, {
          label: "工作时间",
          english: "",
          value: ""
        }, {
          label: "转正时间",
          english: "",
          value: ""
        }]
      },
      tableList: [{
        title: "12987122",
        context: "awsdfasf",
        name: "Tom1",
        value: 0
      }, {
        title: "12987122",
        context: "awsdfasf",
        name: "Tom2",
        value: 0
      }, {
        title: "12987124",
        context: "awsdfasf",
        name: "Tom3",
        value: 0
      }, {
        title: "12987125",
        context: "awsdfasf",
        name: "Tom4",
        value: 0
      }, {
        title: "12987126",
        context: "awsdfasf",
        name: "Tom5",
        value: 0
      }],
      tableOnly: false
    }); // onMounted(() => {
    // });
    // 获取考试试题详情
    // const getListDetail = async () => {
    // };

    var allsore = ref(0);

    function hispeopleDetail(_x) {
      return _hispeopleDetail.apply(this, arguments);
    }

    function _hispeopleDetail() {
      _hispeopleDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var res, allpeerScore;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["hispeopleDetail"](id);

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  res.data.score = Number(res.data.score).toFixed(2);
                  allslist.list = res.data;
                  allsore.value = parseInt(allslist.list.peerScore) + parseInt(allslist.list.selfScore) + parseInt(allslist.list.secretaryScore);

                  if (allslist.list.peerScore) {
                    if (!allslist.list.peerScore.indexOf(",")) {
                      allslist.list.allpeerScore = Number(allslist.list.peerScore);
                    } else {
                      allpeerScore = allslist.list.peerScore.split(",");
                      allslist.list.allpeerScore = 0;
                      allpeerScore.forEach(function (item) {
                        allslist.list.allpeerScore = allslist.list.allpeerScore + Number(item);
                      });
                    }
                  }

                  if (allslist.list.peerDetail) {
                    allslist.list.peerDetail.forEach(function (item) {
                      item.sore = 0;
                      item.peerDetail.forEach(function (ite) {
                        item.sore += ite.maxScore;
                      });
                    });
                  }

                  console.log(allslist.list);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _hispeopleDetail.apply(this, arguments);
    }

    if (route.query.userId) {
      hispeopleDetail({
        listId: route.query.listId,
        userId: route.query.userId // userId:store.state.user.user.userId

      });
    } else {
      hispeopleDetail({
        listId: route.query.listId,
        // userId:route.query.userId
        userId: store.state.user.user.userId
      });
    }

    function peopleDetail(_x2) {
      return _peopleDetail.apply(this, arguments);
    }

    function _peopleDetail() {
      _peopleDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["peopleDetail"](id);

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.topData.leftData[0].value = res.data.username;

                  if (res.data.gender == 0) {
                    Data.topData.leftData[1].value = "女";
                  } else {
                    Data.topData.leftData[1].value = "男";
                  }

                  Data.topData.leftData[2].value = res.data.birthday;
                  Data.topData.leftData[3].value = res.data.nationName;
                  Data.topData.leftData[4].value = res.data.mobile;
                  Data.topData.leftData[5].value = res.data.leaderIdentityName;
                  Data.topData.leftData[6].value = res.data.organizeName;
                  Data.topData.rightData[0].value = res.data.nativePlace;
                  Data.topData.rightData[1].value = res.data.educationName;
                  Data.topData.rightData[2].value = res.data.degreeName;
                  Data.topData.rightData[3].value = res.data.partyDate;
                  Data.topData.rightData[4].value = res.data.workingHours;
                  Data.topData.rightData[5].value = res.data.modifyDate;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _peopleDetail.apply(this, arguments);
    }

    if (route.query.userId) {
      peopleDetail(route.query.userId);
    } else {
      peopleDetail(store.state.user.user.userId);
    }

    return {
      Data: Data,
      // getListDetail,
      peopleDetail: peopleDetail,
      allslist: allslist,
      allsore: allsore
    };
  }
});